/**
 * Scatter series style overrides.
 *
 * Applies marker size (static only — data-driven symbolSize is preserved),
 * marker shape, and OLS regression line via ECharts markLine.
 */
import type { TypeStyle } from '../../../../../edit/visualConfig';
import { computeOLSRegression } from '../helpers';

export function applyScatterOverrides(series: any, cs: TypeStyle): any {
  const patched = { ...series };

  // Static marker size — skip when the scatter builder set a data-driven function
  if (cs.markerSize != null && typeof patched.symbolSize !== 'function') {
    patched.symbolSize = cs.markerSize;
  }

  if (cs.markerShape) {
    patched.symbol = cs.markerShape;
  }

  // OLS regression line
  if (cs.regressionLine && Array.isArray(series.data) && series.data.length >= 2) {
    const reg = computeOLSRegression(series.data);
    if (reg) {
      patched.markLine = {
        silent: true,
        symbol: 'none',
        lineStyle: { type: 'dashed', width: 1.5, opacity: 0.6 },
        data: [[
          { coord: [reg.minX, reg.slope * reg.minX + reg.intercept] },
          { coord: [reg.maxX, reg.slope * reg.maxX + reg.intercept] },
        ]],
        label: { show: false },
      };
    }
  }

  return patched;
}